<template>
  <q-table flat bordered :data="invoicesPayments" :columns="columns" row-key="id" :pagination="pagination">
    <template v-slot:body-cell-actions="props">
      <q-td :props="props" class="text-center">
        <q-btn
          flat
          color="primary"
          @click="showInvoice(props.row.outbound_invoice_uuid)"
          icon="fas fa-file-invoice-dollar"
        >
          <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
            {{ $t('view_bill') }}
          </q-tooltip>
        </q-btn>

        <div class="inline-block" v-if="!props.row.file_id">
          <q-btn color="primary" icon="cloud_upload" flat @click="$refs[`fileInput_${props.row.id}`].pickFiles()">
            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px"> Upload NF</q-tooltip>
          </q-btn>
          <q-file
            :ref="'fileInput_' + props.row.id"
            class="hidden"
            accept=".pdf,.jpg,.jpeg,.png"
            @input="(file) => handleFileUpload(file, props.row)"
          />
        </div>

        <div class="inline-block" v-else>
          <q-btn
            color="primary"
            icon="mdi-eye-outline"
            flat
            @click="openNfPDF(props.row)"
          >
            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
              {{ $t('view_invoice') }}</q-tooltip
            >
          </q-btn>
          <img :src="temporaryImgUrl" />
        </div>
      </q-td>
    </template>
    <template v-slot:header-cell-detailing="props">
    <q-th :props="props">
        <div class="flex items-center">
            Detalhamento
                <q-tooltip content-class="bg-primary">{{ $t('view_csv_details') }}
            </q-tooltip>
        </div>
    </q-th>
    </template>

    <template v-slot:body-cell-detailing="props">
        <q-td :props="props">
            <q-btn
            dense
            round
            flat
            color="primary"
            icon="archive"
            @click="downloadInvoiceDetails(props.row.invoice_payments_ids)"
            :loading="isDownloading"
            >
            <q-tooltip>{{ $t('view_csv_details') }}</q-tooltip>
            </q-btn>
        </q-td>
    </template>

    <template v-slot:bottom>
      <!-- <pagination-table
                @change="getInvoicesPayments"
                :data="reqPagination"
                :pagination="pagination"
            /> -->
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        Total:{{ reqPagination.total }}
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
  </q-table>
</template>

<script>
import FinancialMixin from '../../mixins/FinancialMixin';

export default {
  name: 'ListApproveInvoices',
  mixins: [FinancialMixin],
  props: {
    id: {
      type: [String, Number],
      require: true
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getAffiliateInvoicesPayments(
          `page=${this.currentPage}%26`,
          `perPage=${this.pagination.rowsPerPage}%26affiliate_id=${this.id}`
        );
      }
    }
  },

  created() {
    this.getAffiliateInvoicesPayments(null, `%26perPage=${this.pagination.rowsPerPage}%26affiliate_id=${this.id}`);
  },

  data() {
    return {
      isDownloading: false,
      temporaryImgUrl: '',
      params: {
        payout: null,
        paymentDay: null
      },
      columns: [
        {
          name: 'yearmonth',
          required: true,
          label: this.$t('invoice_period'),
          align: 'left',
          field: 'oi_yearmonth',
          sortable: true
        },
        // {
        //   name: 'id',
        //   required: true,
        //   label: 'ID da Fatura',
        //   align: 'left',
        //   field: 'id',
        //   sortable: true
        // },
        // {
        //   name: 'created_at',
        //   required: true,
        //   label: 'Data da Fatura',
        //   align: 'left',
        //   field: 'invoices_payments_created_at',
        //   format: (value) => this.formatPaymentDate(value),
        //   sortable: true
        // },
        {
          name: 'total_commissions',
          required: true,
          label: this.$t('invoice_amount'),
          align: 'left',
          field: 'total_commissions',
          format: (total_commissions) => `R$ ${total_commissions}`,
          sortable: true
        },
        {
          name: 'detailing',
          required: true,
          label: this.$t('details'),
          align: 'left',
          sortable: false
        },
        {
          name: 'date',
          required: true,
          label: this.$t('invoice_date'),
          align: 'left',
          field: 'payment_day',
          format: (value) => this.formatPaymentDate(value),
          sortable: true
        },
        {
          name: 'id_invoices_payments',
          required: true,
          label: this.$t('invoice_number'),
          align: 'left',
          field: 'invoice_payments_ids',
          sortable: true
        },
        {
          name: 'id_states',
          required: true,
          label: 'Status',
          align: 'left',
          field: 'id_states',
          format: (state) => this.formatStates(state),
          sortable: true
        },
        {
          name: 'actions',
          label: this.$t('actions'),
          align: 'center',
          field: 'actions',
          sortable: false
        }
      ],
      pagination: {
        sortBy: 'trademark',
        descending: true,
        rowsPerPage: 10
      }
    };
  },

  methods: {
    async downloadInvoiceDetails(invoiceIds) {
        this.isDownloading = true;
      await this.generateCommissionsDetailsCsv(
        Array.isArray(invoiceIds) ? invoiceIds : invoiceIds.split(',')
      );
      this.isDownloading = false;
    },

    formatPaymentDate(date) {
      if (date == null) return 'Sem data definida';
      return this.$moment(date).format('L');
    },

    showInvoice(invoiceHash) {
      let route = this.$router.resolve({
        path: `/affiliate/invoice/${invoiceHash}`
      });
      window.open(route.href, '_blank');
    },

    formatStates(state) {
      switch (state) {
        case 1:
        case '1':
          return this.$t('pending');

        case '2':
        case 2:
          return this.$t('liberated');

        case 3:
        case '3':
          return this.$t('requested');

        case 4:
        case '4':
          return this.$t('approved');

        case 5:
        case '5':
          return this.$t('paid');

        case 11:
        case '11':
          return this.$t('refused');

        case 12:
        case '12':
          // return 'Pré-Aprovado';
          return this.$t('requested');

        default:
          return '-';
      }
    },
    async openNfPDF(row) {
      this.$emit('showNfPopUp', row);
    },

    async handleFileUpload(file, row) {
      if (!file || !row?.id) {
        this.$q.notify({
          type: 'warning',
          message: 'Arquivo ou ID da fatura não encontrado.'
        });
        return;
      }

      try {
        this.onLoading(true);
        const url = await this.uploadAffiliateNF(row.affiliate_id, row.oi_yearmonth, file);
        const { status } = await this.saveInvoiceUploadUrl(
          url,
          row.affiliate_id,
          row.invoice_payments_ids.split(','),
          row.oi_yearmonth
        );
        if (status == 201) {
          this.successNotify('Upload realizado com sucesso');
          this.getAffiliateInvoicesPayments(
            null,
            `%26perPage=${this.pagination.rowsPerPage}%26affiliate_id=${this.id}`
          );
        }
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>
<style scoped>
.q-table th.text-right {
  text-align: right !important;
  padding-right: 16px !important; /* ajusta se necessário */
}
</style>
